// extracted by mini-css-extract-plugin
export var promotionLink = "_wa-0";